import React, { useEffect, useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router";
import { servicesMetaMap } from "../../utils/meta-tags";

interface IServiceCoverComponentProps {
    backgroundImage?: string;
    path?: string;
    subTitle?: string;
    title: string;
    urls?: { path: string; label: string }[];
}

export const ServiceCoverComponent: React.FC<IServiceCoverComponentProps> = ({
    backgroundImage,
    path,
    subTitle,
    title,
    urls = [],
}) => {
    useEffect(() => {
        if (backgroundImage) {
            const img = new Image();
            img.src = backgroundImage;
        }
    }, [backgroundImage]);

    // Memoized breadcrumb list
    const breadcrumbList = useMemo(() => {
        if (!urls.length) return null;

        return (
            <nav className="breadcrumbs">
                <ol>
                    {urls.map((url) => (
                        <li key={url.path} className="current">
                            <Link to={url.path}>
                                <span style={{ color: "white" }}>
                                    {url.label}
                                </span>
                            </Link>
                        </li>
                    ))}
                </ol>
            </nav>
        );
    }, [urls]);

    const meta = servicesMetaMap[title] || {
        title: `${title} - iTalent`,
        description: `Learn more about ${title} at iTalent.`,
        keywords: `iTalent, ${title}`,
    };

    return (
        <>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <meta name="keywords" content={meta.keywords} />
            </Helmet>
            <div
                className="page-title dark-background"
                data-aos="fade"
                style={{
                    backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    transition: "background-image 0.3s ease-in-out",
                }}
            >
                <div className="container position-relative">
                    <h1 data-aos="fade-up" data-aos-delay="100">{title}</h1>
                    <div data-aos="fade-up" data-aos-delay="200">{breadcrumbList}</div>
                </div>
            </div>
        </>
    );
};
